import classNames from 'classnames';
import React from 'react';
import './loader.sass';

export default function Loader({
  classes,
  containerClassName,
  dot = false,
  visible = true,
}: {
  classes?: string;
  containerClassName?: string;
  dot?: boolean;
  visible?: boolean;
}) {
  const holderClass = dot ? 'holder' : 'loader-graphic-holder';
  const spanClass = dot ? 'dot' : 'loader-graphic';

  const className = classNames({ invisible: !visible, 'loader-image': !dot }, containerClassName);
  const loaderImageClasses = classNames(classes, spanClass);

  return (
    <div className={className}>
      <div className={holderClass}>
        <span className={loaderImageClasses} />
        <span className={loaderImageClasses} />
        <span className={loaderImageClasses} />
        <span className={loaderImageClasses} />
      </div>
    </div>
  );
}
